import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const tenantDisputes: AppContent['tenantDisputes'] = {
  metaContent: {
    title: MetaContentValues.tenantDisputes.title,
  },
  backLabel: 'Back to Landlord Support',
  pageTitle: 'Tenant disputes',
  goingToCourt:
    "Going to court should always be a last resort. It's expensive and emotional for you and your tenant.",
  talkingToTenant:
    "Talking to your tenant should be your first option. If this doesn't work, try explaining the problem to them in writing and ask them to write back or contact you another way.",
  ifThatFails: 'If that fails, you can try a mediation service.',

  mediation: {
    title: 'How does mediation work?',
    askAProfessional:
      "It's where you ask a professional to help you come to an impartial agreement. It's usually quicker and cheaper than going to court. Your local council might be able to help you find a mediator, or you can ",
    findOneHereLinkLabel: 'find one here',
    findOneHereLinkHref: 'https://civilmediation.org/mediator-search',
    basedInEnglandOrWales: " if you're based in England or Wales.",
    northernIreland:
      'In Northern Ireland, the mediation service is part of the landlord registration process.',
    findMediatorLinkLabel: 'Find a mediator in Scotland',
    findMediatorLinkHref: 'https://www.scottishmediation.org.uk/',
    needToUse: "You'll need to use the ",
    scottishArbitrationServiceLinkLabel: 'Scottish Arbitration Service',
    scottishArbitrationServiceLinkHref:
      'https://scottisharbitrationcentre.org/',
    disputeAboutProperty:
      ' if you have a dispute about a rented property deposit in Scotland.',
  },
  courtEnglandWales: {
    title: 'If you need to go to court - England and Wales',
    lastResort:
      "As we've said previously, this should be your last resort. But if you've tried everything else, then legal action is the way to go.",
    youNeedToGo: "You'll need to go to the ",
    smallClaimsCourtLinkLabel: 'small claims court',
    smallClaimsCourtLinkHref: 'https://www.gov.uk/make-court-claim-for-money',
    repairClaims:
      ' for cases up to £10,000 or £1,000 for property repair claims.',
    repossession:
      "If you want to repossess a property because you're owed rent, you can ",
    onlineClaimLinkLabel: 'make an online claim',
    onlineClaimLinkHref: 'https://www.possessionclaim.gov.uk/pcol',
    period: '.',
  },
  courtScotland: {
    title: 'Scotland',
    firstTier:
      'The first-tier tribunal for Scotland Housing and Property Chamber can help resolve:',
    listItems: [
      'Tenancy term disputes.',
      'Rent disputes.',
      'Repair disputes.',
      'Property entry disputes.',
      'Eviction disputes.',
      'Wrongful tenancy termination disputes.',
    ],
    housingChamberLinkLabel: 'Go to Housing and Property Chamber Scotland',
    housingChamberLinkHref: 'https://housingandpropertychamber.scot/contact-us',
  },
  courtNorthernIreland: {
    title: 'Northern Ireland',
    tenantDisputes:
      'Tenant disputes in Northern Ireland need to be resolved using the ',
    disputeResolutionLinkLabel: 'dispute resolution mechanism',
    disputeResolutionLinkHref:
      'https://www.nidirect.gov.uk/articles/sorting-out-disputes',
    reduceCourtCases:
      '. This was set up to try and reduce the number of courts cases.',
  },

  evictingTenantsAccordion: {
    label: 'Evicting tenants',
    evictingTitle: 'Evicting',
    followProcedures:
      "There are procedures you must follow to evict tenants. Not doing so could mean you're guilty of harassing or illegally evicting them.",
    fixedTermTitle: 'If your tenants have a fixed-term tenancy',
    mustServe: 'You must serve them a ',
    sectionNoticeLinkLabel: 'Section 21 notice',
    sectionNoticeLinkHref:
      'https://www.gov.uk/evicting-tenants/section-21-and-section-8-notices',
    getPropertyBack:
      ' if you want to get the property back after the fixed-term period ends.',
    weekByWeekTitle:
      'If your tenants have a week-by-week or monthly rolling tenancy agreement, or fixed-term tenancy',
    serveThem: 'Serve them a ',
    section8NoticeLinkLabel: 'Section 8 notice',
    brokenTerms: " if they've broken the terms of the tenancy.",
    applyFor: 'Apply for a ',
    standardPossessionLinkLabel: 'standard possession order',
    standardPossessionLinkHref:
      'https://www.gov.uk/possession-claim-online-recover-property',
    oweRent: " if they owe you rent and don't leave by a specified date.",
    notClaimingUnpaidRent:
      "If you're not claiming any unpaid rent, you can apply for an ",
    acceleratedPossessionOrderLinkLabel: 'accelerated possession order',
    acceleratedPossessionOrderLinkHref:
      'https://www.gov.uk/evicting-tenants/accelerated-possession-orders',
    period: '.',
    stillDontLeave: "If they still don't leave after this, apply for a ",
    warrantForPossessionLinkLabel: 'warrant for possession',
    warrantForPossessionLinkHref:
      'https://www.gov.uk/evicting-tenants/eviction-notices-and-bailiffs',
    removeTenants: ' as this means bailiffs can remove tenants.',
  },

  disputeAdviceAccordion: {
    label: 'Organisations who offer free dispute advice',
    shelterLinkLabel: 'Shelter',
    shelterLinkHref: 'https://england.shelter.org.uk/housing_advice',
    shelterCymruLinkLabel: 'Shelter Cymru in Wales',
    shelterCymruLinkHref: 'https://sheltercymru.org.uk/contact-us',
    citizensAdviceLinkLabel: 'Citizens Advice',
    citizensAdviceLinkHref:
      'https://www.citizensadvice.org.uk/about-us/contact-us',
    civilLegalAdviceLinkLabel: 'Civil Legal Advice',
    civilLegalAdviceLinkHref: 'https://www.gov.uk/civil-legal-advice',
    legalAid: ' (CLA) as part of legal aid - England and Wales only',
  },
};

export default tenantDisputes;
